import React from 'react';

const ErrorMessage = ({ message }) => (
  <div style={{ color: "red", margin: "20px" }}>
    {message}
  </div>
);

export default ErrorMessage;